import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { API_URL } from "../lib/utils";
import axios from "axios";
import { toast } from "sonner";
import { ShieldCheck, Lock, ArrowLeft } from "lucide-react";
import { BackofficeForgotPassword } from "../components/backoffice/BackofficeForgotPassword";

export default function BackofficeLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/backoffice/login`, { email, password }, { withCredentials: true });
      // Sessão fica num cookie HttpOnly definido pelo servidor — nenhum token é guardado no browser
      localStorage.removeItem("backoffice_token");
      toast.success(`Bem-vindo, ${res.data.admin?.name || "Dono"}!`);
      if (res.data.new_device) toast.info(`Dispositivo novo (${res.data.device_label}) — enviámos um aviso para o seu email.`);
      navigate("/backoffice");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : err.response?.status ? `Erro ${err.response.status} ao entrar` : "Sem ligação ao servidor");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white px-4" data-testid="backoffice-login-page">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse 60% 40% at 50% 0%, rgba(34,211,238,0.08), transparent)" }} />
      <div className="w-full max-w-sm relative">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-cyan-500/10 border border-cyan-500/30 mb-4">
            <ShieldCheck className="w-7 h-7 text-cyan-400" />
          </div>
          <h1 className="text-2xl font-bold font-['Outfit']">LUMORA Backoffice</h1>
          <p className="text-sm text-white/50 mt-1">{forgot ? "Recuperar acesso do dono" : "Área reservada do dono da plataforma"}</p>
        </div>
        {forgot ? (
          <BackofficeForgotPassword initialEmail={email} onBack={() => setForgot(false)} />
        ) : (
        <form onSubmit={handleSubmit} className="space-y-4 rounded-2xl border border-white/10 bg-white/[0.03] p-6 backdrop-blur">
          <div className="space-y-1.5">
            <Label htmlFor="bo-email" className="text-white/70">Email</Label>
            <Input
              id="bo-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
              className="bg-white/5 border-white/15 text-white placeholder:text-white/30"
              placeholder="email do dono"
              data-testid="backoffice-email-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="bo-password" className="text-white/70">Palavra-passe</Label>
            <Input
              id="bo-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="bg-white/5 border-white/15 text-white"
              data-testid="backoffice-password-input"
            />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-cyan-500 hover:bg-cyan-400 text-black font-semibold" data-testid="backoffice-login-submit">
            <Lock className="w-4 h-4 mr-2" />
            {loading ? "A entrar..." : "Entrar no Backoffice"}
          </Button>
          <button type="button" onClick={() => setForgot(true)} className="w-full text-center text-sm text-white/40 hover:text-cyan-300 transition-colors" data-testid="backoffice-forgot-password-btn">
            Esqueci a palavra-passe
          </button>
        </form>
        )}
        <div className="text-center mt-6">
          <Link to="/" className="text-sm text-white/40 hover:text-white/70 inline-flex items-center gap-1" data-testid="backoffice-back-home">
            <ArrowLeft className="w-3.5 h-3.5" /> Voltar ao site
          </Link>
        </div>
      </div>
    </div>
  );
}
